module.exports = __webpack_public_path__ + "static/media/c.28e74ad1.webp";